(() => {
  const initSection = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const materialButtons = [...root.querySelectorAll('[data-material-select]')];
    const backgroundImage = root.querySelector('[data-material-background-image]');
    const backgroundMobile = root.querySelector('[data-material-background-mobile]');
    const productImage = root.querySelector('[data-material-product-image]');
    const productMobile = root.querySelector('[data-material-product-mobile]');
    const variantText = root.querySelector('[data-material-variant-text]');
    const shipping = root.querySelector('[data-material-shipping]');
    const price = root.querySelector('[data-material-price]');
    const comparePrice = root.querySelector('[data-material-compare-price]');
    const paymentFirst = root.querySelector('[data-material-payment-first]');
    const paymentSecond = root.querySelector('[data-material-payment-second]');
    const shopLink = root.querySelector('[data-material-shop-link]');

    const setImage = (image, url) => {
      if (!image) return;
      image.src = url || '';
      image.hidden = !url;
    };

    const setSource = (source, url) => {
      if (!source) return;
      source.srcset = url || '';
    };

    const updateMaterial = (button) => {
      if (!button) return;

      materialButtons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });

      const desktopBackground = button.dataset.backgroundDesktop || '';
      const mobileBackground = button.dataset.backgroundMobile || desktopBackground;
      const desktopProduct = button.dataset.productImageDesktop || '';
      const mobileProduct = button.dataset.productImageMobile || desktopProduct;

      setImage(backgroundImage, desktopBackground);
      setSource(backgroundMobile, mobileBackground);
      setImage(productImage, desktopProduct);
      setSource(productMobile, mobileProduct);

      if (variantText) {
        variantText.textContent = button.dataset.variantText || '';
      }

      if (shipping) {
        const preorderInfo = button.dataset.preorderInfo || '';
        shipping.textContent = preorderInfo;
        shipping.hidden = !preorderInfo;
      }

      if (price) {
        price.textContent = button.dataset.priceDisplay || '';
      }

      if (comparePrice) {
        comparePrice.textContent = button.dataset.comparePriceDisplay || '';
        comparePrice.classList.toggle('is-hidden', button.dataset.showCompare !== 'true');
      }

      if (paymentFirst) {
        paymentFirst.textContent = button.dataset.paymentFirst || '';
      }

      if (paymentSecond) {
        paymentSecond.textContent = button.dataset.paymentSecond || '';
      }

      if (shopLink) {
        const productUrl = button.dataset.productUrl || '#';
        const isDisabled = productUrl === '#';
        shopLink.href = productUrl;
        shopLink.classList.toggle('is-disabled', isDisabled);
        if (isDisabled) {
          shopLink.setAttribute('aria-disabled', 'true');
        } else {
          shopLink.removeAttribute('aria-disabled');
        }
      }
    };

    materialButtons.forEach((button) => {
      button.addEventListener('click', () => updateMaterial(button));
    });

    updateMaterial(materialButtons.find((button) => button.classList.contains('is-active')) || materialButtons[0]);
  };

  const initAll = () => {
    document.querySelectorAll('.material-switch-product-offer[data-section-id]').forEach(initSection);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.matches?.('.material-switch-product-offer[data-section-id]')
        ? event.target
        : event.target.querySelector?.('.material-switch-product-offer[data-section-id]');
    initSection(section);
  });
})();
